import { VF_DATE_PICKER } from 'AppSrc/core/components/forms/form-base-components/v-f-date-picker';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';
import moment from 'moment-timezone';
// validation relies on the value of another component
import { scheduledStartDate } from './scheduled-start-date';

const fieldId = 'scheduled-end-date';

let endDateValue = 0;

const getEndDate = () => {
  if (endDateValue) {
    return moment.tz(endDateValue, DEFAULT_TIMEZONE).endOf('day').valueOf();
  }
  return Date.now();
};

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  // define thisMoment (end date) to check if it's before startMoment (the start date)
  const thisMoment = moment.tz(values[fieldId], DEFAULT_TIMEZONE).startOf('minute');
  const startMoment = moment.tz(values[scheduledStartDate.id], DEFAULT_TIMEZONE).startOf('minute');


  // figure out the differences between thisMoment and startMoment
  const timeDiffMinutes = thisMoment.diff(startMoment, 'minutes');
  const timeDiffYears = thisMoment.diff(startMoment, 'years');
  const timeDiffMonths = thisMoment.diff(startMoment, 'months');

  // define the differences in time that are no acceptable
  const maxMinutesDiff = 30;
  const maxYearDiff = 5;
  const maxMonthDiff = 3;

  // ie, 1:00 -> 1:29 === error but 1:00 -> 1:30 is fine!
  const lessThanMaxMinutesDiff = timeDiffMinutes < maxMinutesDiff;
  // ie, if max year diff is 5, the user can requst up to 4 years and 364 days in advance (assuming all 5 years are 365 days long)
  const moreThanMaxYearDiff = timeDiffYears >= maxYearDiff;

  // ie, if max month diff is 3, the user can requst up to 2 Months and 29 days
  const moreThanMaxMonthDiff = timeDiffMonths >= maxMonthDiff;


  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_DATE_PICKER);

  // setting the end here so, it can be use in outage logic to diable date after end dates
  if (!noValue && !lessThanMaxMinutesDiff && !moreThanMaxYearDiff) {
    endDateValue = values[fieldId];
  }

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select a valid date and time' : null);
  errors[INLINE_ERRORS].push(lessThanMaxMinutesDiff ? 'End date/time must be at least 30mins after the start date/time' : null);
  errors[INLINE_ERRORS].push(moreThanMaxYearDiff ? 'End date/time must be within 5 years of date/time' : null);
  errors[INLINE_ERRORS].push(moreThanMaxMonthDiff ? 'End date/time must be within 3 Months of Start date/time' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

// This overwritten by the form :)
const initialValues = null;

const vFParams = {
  fieldTitle: 'Scheduled end date/time',
  displayType: 'big',
};

const scheduledEndDate = {
  id: fieldId,
  validator,
  vFParams,
  initialValues,
  fieldType: VF_DATE_PICKER,
  getEndDate,
};

export { scheduledEndDate };
